import { Grid, Typography } from '@mui/material'
import { useScreenSize } from 'hooks/useScreenSize/useScreenSize'
import Logo from 'assets/logo.png'
import { useTranslation } from 'react-i18next'
import GreenFullscreen from 'router/layouts/InstallLayout'

export default function ErrorBoundaryPage() {
    const { t } = useTranslation()
    const { isMobile } = useScreenSize()

    return (
        <GreenFullscreen
            container
            alignItems={'center'}
            alignContent={'center'}
            justifyContent={'center'}
        >
            <Grid>
                <img
                    style={{
                        width: isMobile ? 340 : 412,
                    }}
                    src={Logo}
                    alt="logo"
                />
            </Grid>
            <Grid size={10}>
                <Typography variant="h4" color="white" align="center">
                    {t('error_boundary_message')}
                </Typography>
            </Grid>
        </GreenFullscreen>
    )
}
